import { useCallback } from 'react';
import { ActionEnum, useDispatch, useMappedState } from '../store/store';
export var useVisibility = function (fieldName) {
    var visibleFieldList = useMappedState((function (state) { return state.visibleFieldList; }));
    var fieldIsVisible = useMappedState(useCallback(function (state) {
        return !!state.visibleFieldList.find(function (visibleFieldName) { return visibleFieldName === fieldName; });
    }, [fieldName]));
    var dispatch = useDispatch();
    var setVisibleFieldList = useCallback(function (fieldNameList) {
        return dispatch({ type: ActionEnum.SET_VISIBILITY, fieldNameList: fieldNameList });
    }, [dispatch]);
    return { fieldIsVisible: fieldIsVisible, visibleFieldList: visibleFieldList, setVisibleFieldList: setVisibleFieldList };
};
//# sourceMappingURL=visibility.hook.js.map